import React from "react";
import HowToVideo from "../ui-building-blocks/modal/how-to-video";
import {
  CEO_DECISIONS_VIDEO,
  PRODUCT_DEVELOPMENT_DECISIONS_VIDEO,
  PRODUCT_MARKETING_DECISIONS_VIDEO,
  OPERATIONS_DECISIONS_VIDEO,
  FINANCE_DECISIONS_VIDEO
} from "../../data/videos-links";
import { detectMobile } from "../../services/utils";

function getVideoLink(type) {
  let url = "";

  switch (type) {
    case "ceo":
      url = CEO_DECISIONS_VIDEO;
      break;
    case "product_development":
      url = PRODUCT_DEVELOPMENT_DECISIONS_VIDEO;
      break;
    case "product_marketing":
      url = PRODUCT_MARKETING_DECISIONS_VIDEO;
      break;
    case "operations":
      url = OPERATIONS_DECISIONS_VIDEO;
      break;
    case "finance":
      url = FINANCE_DECISIONS_VIDEO;
      break;
    default:
    // do nothing
  }

  return url;
}

function RoleButtons({ type = "" }) {
  const url = getVideoLink(type);
  const isMobile = detectMobile();
  const divClass = isMobile ? "row" : "role-buttons-container";

  return (
    <div className={divClass}>
      <HowToVideo url={url} />
    </div>
  );
}

export default RoleButtons;



// WEBPACK FOOTER //
// ./src/components/role-buttons/index.js